import { useEffect, useRef } from 'react';

/**
 * Standard list pagination fetch:
 * - reset to page 1 when filters change
 * - refetch when page or fetch callback changes
 * - skip an in-flight later page when filters reset, so the next response replaces from page 1
 */
export default function usePaginatedListFetch({
  fetchPage,
  setCurrentPage,
  currentPage = 1,
  resetPageDeps,
  debounceWhen = '',
  debounceMs = 300,
}) {
  const pendingReset = useRef(false);

  useEffect(() => {
    pendingReset.current = true;
    setCurrentPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, resetPageDeps);

  useEffect(() => {
    if (pendingReset.current && currentPage !== 1) return undefined;
    pendingReset.current = false;
    const shouldDebounce = debounceWhen === true ? true : Boolean(debounceWhen);
    const delay = shouldDebounce ? debounceMs : 0;
    const timer = setTimeout(() => {
      fetchPage();
    }, delay);

    return () => clearTimeout(timer);
  }, [fetchPage, currentPage, debounceWhen, debounceMs]);
}
